import { NavLink } from "react-router-dom";
import { usePartnerPortalBase } from "../../components/partner/PartnerPortalBaseProvider";
import { useLocale } from "../../intl";
import { PARTNER_SETTINGS_COPY as COPY } from "./partnerCasaMapaSettingsShared";
import "../../styles/partnerPortalDashboard.css";
import "../../styles/partnerCasaMapaProfile.css";

export default function PartnerCasaMapaSettingsShell({
  title,
  subtitle,
  message,
  error,
  children,
}) {
  const { t } = useLocale();
  const { path } = usePartnerPortalBase();

  return (
    <div className="cm-partner-settings">
      <header className="cm-partner-settings__hero partner-dashboard-hero">
        <div>
          <p className="cm-partner-settings__eyebrow">{t(`${COPY}.eyebrow`)}</p>
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
        <nav className="cm-partner-settings__toc" aria-label={t(`${COPY}.tocLabel`)}>
          <NavLink to={path("profile/inventory")}>{t(`${COPY}.toc.inventory`)}</NavLink>
          <NavLink to={path("profile/crm")}>{t(`${COPY}.toc.crm`)}</NavLink>
          <NavLink to={path("profile")} end>
            {t(`${COPY}.toc.account`)}
          </NavLink>
        </nav>
      </header>

      {message ? <p className="cm-partner-settings__alert">{message}</p> : null}
      {error ? (
        <p className="cm-partner-settings__alert cm-partner-settings__alert--error" role="alert">
          {error}
        </p>
      ) : null}

      {children}
    </div>
  );
}
